import { Component }                    from '@angular/core';
import { ViewChild, OnInit, OnDestroy } from '@angular/core';
import { NavController, NavParams }     from 'ionic-angular';
import { Content }                      from 'ionic-angular';

import { BookService }                  from "../../services/book.service";
import { MiscService }                  from "../../services/misc.service";
import { Book }                         from "../../models/book";
import helper                           from "../../helper";

@Component({
  selector: 'dra-reader-inner',
  templateUrl: 'reader-inner.component.html'
})
export class ReaderInnerComponent implements OnInit, OnDestroy {
  @ViewChild('reader') content: Content;
  private bookAlias: string;
  private chapterAlias: string;
  private loggedIn: boolean = true;
  private book: Book;
  private swiperOptions;

  public constructor(
    private navController: NavController,
    private navParams: NavParams,
    private bookService: BookService,
    private miscService: MiscService
  ) {
  }

  public async ngOnInit() {
    try {
      this.bookAlias = this.navParams.get('bookAlias');
      this.chapterAlias = this.navParams.get('chapterAlias');
      let previousView = this.navController.getPrevious();
      if (previousView.id == 'Book') previousView.data = {bookAlias: this.bookAlias};
      // debugger;

      // this.userService.getUser();
      this.init();

      // console.log(this.navController._views);

    } catch (error) {
      console.log(error);
    }
  }
  public ngOnDestroy() {
    this.bookService.stopPreloadChapters();
  }
  public async init(): Promise<void> {
    let book: Book;
    this.miscService.startLoading();
    try {
      book = this.book = await this.bookService.getBook(this.bookAlias, {}, true);
    } catch (error) {
      this.miscService.stopLoading();
      return;
    }

    this.miscService.stopLoading();
    this.miscService.setTitle(book.name);

    let currentIndex = helper.findIndex(book.chapters, this.chapterAlias, 'alias');
    if (currentIndex < 0) currentIndex = 0;

    this.bookService.preloadChapters(book.alias, currentIndex);

    this.swiperOptions = {
      total: book.chapters.length,
      startIndex: currentIndex,
      currentIndex: currentIndex,
      getItem: index => this.getChapter(book, index),
      onChange: index => this.onChapterChange(book, index),
    };
  }
  public async getChapter(book, index): Promise<any> {
    let chapter = book.chapters[index];
    if (!chapter) throw {message: 'Chapter not available'};

    if (index == this.swiperOptions.currentIndex) {
      this.miscService.startLoading();
    }
    let _chapter = await this.bookService.getChapter(book.alias, chapter.alias);
    if (index == this.swiperOptions.currentIndex) {
      this.miscService.stopLoading();
    }

    return _chapter;
  }
  public goChapter(index): void {
    this.swiperOptions.swiper && this.swiperOptions.swiper.goTo(index);
  }
  public prevChapter(): void {
    this.swiperOptions.swiper && this.swiperOptions.swiper.prev();
  }
  public nextChapter(): void {
    this.swiperOptions.swiper && this.swiperOptions.swiper.next();
  }

  private async onChapterChange(book: Book, chapterIndex: number): Promise<void> {
    let item = book.chapters[chapterIndex];

    this.chapterAlias = item.alias;
    this.miscService.changeUrl(`books/${book.alias}/${item.alias}`, {}, false);
    this.miscService.setTitle(`${book.name} - ${item.name}`);

    if (this.content) this.content.scrollTo(0, 0);

    try {
      // console.log(this.navController._views);
      if (this.loggedIn && !item.read) {
        await this.bookService.read(book.id, item.id);
        item.read = true;
      }
    } catch (error) {
      console.log(error);
    }

    this.bookService.preloadChapters(book.alias, chapterIndex);
  }
}



// WEBPACK FOOTER //
// ./src/components/reader/reader-inner.component.ts